import { render, staticRenderFns } from "./MenuHeaderOptions.vue?vue&type=template&id=6336c9c6&scoped=true&"
import script from "./MenuHeaderOptions.vue?vue&type=script&lang=js&"
export * from "./MenuHeaderOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuHeaderOptions.vue?vue&type=style&index=0&id=6336c9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336c9c6",
  null
  
)

export default component.exports